import React from "react";
import "./CourseCard.scss";
import {
  BookOutlined,
  TrophyOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import IconTag from "../../../../components/IconTag/IconTag";
import Card from "../../../../components/Card/Card";
import { Popconfirm, Tooltip, Rate } from "antd";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../../core/hooks/useAuth";
import { checkUserRole } from "../../../../core/utils/helpers";

function CourseCard({
  id,
  category,
  title,
  difficulty,
  description,
  nameSection,
  handleDeleteCourse,
  cancel,
  imagePath,
  hasUpcomingTraining,
  ratingCourse,
  modulesCount
}) {

  const { authenticatedUser } = useAuth();

  const navigateToCourse = (id) => {
    return () => {
      navigate("/courses/" + id);
    };
  };

  const navigate = useNavigate();

  const handleEditClick = () => {
    navigate(`/edit-course/${id}`);
  };

  let imgOrigin = `${process.env.REACT_APP_CORE_PATH}/courses/images/${imagePath}`;

  return (
    <div
      className={`course-card ${
        hasUpcomingTraining === true ? "has-upcoming-training" : ""
      }`}
    >
      <Card>
        <div
          className="card-image"
          style={{
            backgroundImage: imgOrigin
              ? `url(${imgOrigin})`
              : "https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg",
          }}
          onClick={navigateToCourse(id)}
        >
          <div className="image-modal">
            <button onClick={navigateToCourse}>Preview {nameSection}</button>
          </div>
        </div>
        <div className="top-section">
          <p>{category || "None"}</p>
          <div className="icons-row">
            <IconTag
              Icon={TrophyOutlined}
              title={difficulty || "Intermediate"}
            />
            <IconTag
              Icon={BookOutlined}
              title={`Lesson : ${modulesCount }`}
            />
          </div>
        </div>
        <div className="middle-section">
        <h3>{title || "None"}</h3>
          { checkUserRole(authenticatedUser, ["Admin", "Trainer"], <div className="icons-row">
              <EditOutlined className="editIcon" onClick={handleEditClick} />
              <Popconfirm
                title="Delete the course"
                description="Are you sure to delete this course ?"
                onConfirm={(e) => handleDeleteCourse(id, e)}
                onCancel={(e) => cancel(e)}
                okText="Yes"
                cancelText="No"
              >
                <>
                  <Tooltip placement="bottomLeft" title="Delete course">
                    <DeleteOutlined className="trashIcon" />
                  </Tooltip>
                </>
              </Popconfirm>
            </div>
            )
          }

        </div>
        <div className="bottom-section">
          <h4>{description || "None"}</h4>
        </div>
        <div className="course-rating">
           <Rate
              disabled
              defaultValue={ratingCourse ?? 0}
            />
        </div>
      </Card>
      {hasUpcomingTraining && <span className="planified-label">Planned</span>}
    </div>
  );
}

export default CourseCard;
